export enum QuoteSourceTypes {
  CREATED_EXTERNALLY = 'created_externally',
  CREATED_IN_RAP = 'created_in_RAP',
  RESUMED_IN_RAP_FROM_FIND_USER = 'resumed_in_RAP_from_find_user',
  // Backward compatibility for RAP clients deployed before the Open Leads -> Quotes rename.
  RESUMED_IN_RAP_FROM_OPEN_LEADS = 'resumed_in_RAP_from_open_leads',
  RESUMED_IN_RAP_FROM_QUOTES = 'resumed_in_RAP_from_quotes',
  CREATED_IN_RAP_FOR_ENDORSEMENT = 'created_in_RAP_for_endorsement',
  CREATED_EXTERNALLY_FOR_ENDORSEMENT = 'created_externally_for_endorsement',
}
